export default __webpack_public_path__ + "static/cardImg2-51dd25e0607d0ce17d900bf8d41fc511.webp";